import { createContext, useContext } from "react";

import { SearchContext } from "../CommandPalette";

interface ModeContextProps {
  mode: string | SearchContext;
  setMode: (value: string) => void;
  idModeEnabled: boolean;
}

export const ModeContext = createContext<ModeContextProps>({
  mode: "default",
  setMode: () => null,
  idModeEnabled: false,
});

export const ModeContextProvider = ModeContext.Provider;

export const useModeContext = (): ModeContextProps => useContext(ModeContext);
